var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroupSideMenuCalendarM(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6673 1.33398V4.00065M5.33398 1.33398V4.00065",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9987 7.16413C13.999 7.21174 13.9992 7.25988 13.9993 7.30857L13.9987 7.16413ZM13.9987 7.16413C13.9892 5.19643 13.9082 4.13637 13.2189 3.44706C12.4379 2.66602 11.1808 2.66602 8.66667 2.66602H7.33333C4.81917 2.66602 3.5621 2.66602 2.78105 3.44706C2 4.22812 2 5.48519 2 7.99935V9.33268C2 11.8468 2 13.1039 2.78105 13.8849C3.40977 14.5137 4.34695 14.6363 6 14.6602H7",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6.66602H14",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9992 13.6707C12.7427 13.6707 13.3914 13.2651 13.736 12.663M11.9992 13.6707C11.2558 13.6707 10.6071 13.2651 10.2624 12.663M11.9992 13.6707V14.8707M13.736 12.663L14.7992 13.2705M13.736 12.663C13.9035 12.3706 13.9992 12.0318 13.9992 11.6707C13.9992 11.3095 13.9035 10.9706 13.7359 10.6781M10.2624 12.663L9.19922 13.2705M10.2624 12.663C10.0949 12.3706 9.99922 12.0318 9.99922 11.6707C9.99922 11.3095 10.095 10.9706 10.2625 10.6781M11.9992 9.6707C12.7426 9.6707 13.3912 10.0762 13.7359 10.6781M11.9992 9.6707C11.2559 9.6707 10.6072 10.0762 10.2625 10.6781M11.9992 9.6707V8.4707M13.7359 10.6781L14.7992 10.0705M10.2625 10.6781L9.19922 10.0705",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupSideMenuCalendarM);
export default __webpack_public_path__ + "static/media/group_side_menu_calendar_m.6213045adb075881193dc16edd4bd8db.svg";
export { ForwardRef as ReactComponent };